import { render, staticRenderFns } from "./SelectLoad.vue?vue&type=template&id=bea1e5c8"
import script from "./SelectLoad.vue?vue&type=script&lang=js"
export * from "./SelectLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports